module.exports = __webpack_public_path__ + "static/media/CrossIcon.072613aa.svg";